import React from 'react';
import Modal from '@/ctComponents/Modal';
import { useEffect } from 'react';
import { noScroll, removeNoScroll } from '@/actions/Helper';
import { TableV2 } from '@/components/TableV2';

const TABLE_HEADERS = ['#', 'Referral Name', 'Reward Amount', 'Earned Date'];

export const RewardModal = ({ show, setShow, data }) => {
  useEffect(() => {
    show ? noScroll() : removeNoScroll();
  }, [show]);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options).replace(',', ', ');
  };

  const prepareTableData = () => {
    return data.map((item, index) => ({
      id: item.id,
      cellData: [
        index + 1,
        item.f_name || '-',
        '$100',
        formatDate(item.created_at),
      ],
    }));
  };

  return (
    <Modal
      minWidth="unset"
      show={show}
      notClose={true}
      children={
        <div className="w-386 overflow-y-scroll overflow-x-hidden lg:overflow-y-hidden">
          <p className="text-primary-text m-0 my-6">
            Track your earned rewards, with details on dates, referral sources,
            and payment status.
          </p>
          <TableV2
            minWidth="unset"
            headers={TABLE_HEADERS}
            data={prepareTableData()}
            emptyMessage="No transactions available"
          />
        </div>
      }
      icon="eye"
      title="View Rewards Detail"
      setShow={setShow}
    />
  );
};
